import { segmentsApi } from '@/api/segmentsApi'
import { concordanceSearchApi } from '@/api/concordanceSearchApi'

import { SegmentSearchRequest, SegmentSearchResponse } from './SegmentSearchModels'
import { ConcordanceSearchRequest, ConcordanceSearchResponse } from './ConcordanceSearchModels'

export async function segmentSearch(request: SegmentSearchRequest): Promise<SegmentSearchResponse> {
    const response = await segmentsApi.searchSegments(request);
    return response as SegmentSearchResponse;
}

export async function concordanceSearch(request: ConcordanceSearchRequest): Promise<ConcordanceSearchResponse> {
    const response = await concordanceSearchApi.search(request);

    if (response) {
        return {
            results: response.results.map((result: any) => ({
                ...result,
                createdOn: new Date(result.createdOn)
            })),
            totalCount: response.totalCount,
            hasMore: response.hasMore
        };
    }

    return {
        results: [],
        totalCount: 0,
        hasMore: false
    };
}
